/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

export const useStyles = makeStyles((styles) => ({
  cardGrid: {
    // paddingTop: theme.spacing(2),
    width: '100%',
    height: '100%',
    // paddingBottom: theme.spacing(2),
  },
}));

const styles = {
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0',
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Nunito', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
  },
  gridPadding: {
    padding: '2px',
  },
  card: {
    height: '100%',
    minHeight: '150px',
    minWidth: '200px',
    display: 'flex',
    flexDirection: 'column',
  },
  cardGrid: {
    paddingTop: '2px',
    width: '100%',
    height: '100%',
    paddingBottom: '2px',
  },
  selectInput: {
    margin: '27px 0px 0px 0px',
    position: 'relative',
    paddingBottom: '10px',
    verticalAlign: 'unset',
  },
  iconsEdit: {
    top: '5%',
    right: '4%',
    position: 'absolute',
    transform: 'translateY(-50%)',
  },
};

export default styles;

export const SelectInput = styled(TextField)`
  & .MuiFormControl-root {
    margin: 27px 0px 0px 0px;
    position: relative;
    padding-bottom: 10px;
    vertical-align: unset;
  }
  ,
  & .MuiFormLabel-root {
    color: #343434 !important;
    font-size: 15px;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-weight: 400;
    line-height: 1.42857;
  }
  ,
  & .MuiInput-underline:after {
    color: #343434 !important;
    font-size: 15px;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-weight: 400;
    line-height: 1.42857;
    border-color: #9c27b0;
  }
  ,
  & .MuiInput-underline:before {
    border-color: #585858 !important;
    border-width: 1px !important;
  }
`;
